import { type any as AnyType } from 'zod/lib/types'

// @ts-ignore
export const InputKey = (name: string, schema: AnyType | null = null) => {
  const separatedPrefix = (prefix: string | null) => {
    const newName = prefix != null ? `${prefix}.${name}` : name
    return InputKey(newName, schema)
  }

  const prefix = (prefix: string | null) => {
    const newName = prefix != null ? `${prefix}${name}` : name
    return InputKey(newName, schema)
  }

  return {
    name,
    prefix,
    separatedPrefix,
    schemaWithName: { [name]: schema },
    schema,
  }
}
